module.exports = __webpack_public_path__ + "static/media/DSC09990.b9749da7.jpg";